import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CountryISO, NgxIntlTelInputComponent, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input-gg';
import { phoneNumberPlaceHolders } from './phone-number-placeholders';
import { HelperService } from 'app/main/pages/edit-template/helper.service';

@Component({
  selector: 'app-phone-input',
  template: `
  <ng-container *ngIf="(landCode | ipToCountry | async) as countryData">
  <ngx-intl-tel-input
      [enableAutoCountrySelect]="true"
      [enablePlaceholder]="true"
      [customPlaceholder]="countryData?.calling_code"
      [searchCountryFlag]="true"
      [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
      [selectFirstCountry]="false"
      [selectedCountryISO]="countryData?.countryCode"
      [preferredCountries]="[CountryISO.Sweden]"
      [maxLength]="15"
      [phoneValidation]="phoneValidation"
      [separateDialCode]="false"
      [numberFormat]="PhoneNumberFormat.National"
      [cssClass]="cssClass"
      name="phone_no"
      (countryChange)="onCountryChange($event)"
      [formControl]="formControl"
    ></ngx-intl-tel-input>
    </ng-container>`,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneNumberInputComponent),
      multi: true,
    },
  ],
  encapsulation: ViewEncapsulation.None
})
export class PhoneNumberInputComponent implements ControlValueAccessor, OnInit {

  @ViewChild(NgxIntlTelInputComponent, { static: false }) ngxIntlTelInput: NgxIntlTelInputComponent;

  @Input() formControl: FormControl;
  @Input() isFormSubmitted: boolean = false;
  @Input() phoneValidation: boolean = true;
  @Input() disabled: boolean = false;
  @Input() phoneGroup: FormGroup;
  @Input() cssVariant: string = '';
  @Output() countrySelected = new EventEmitter<{name: string, dialCode: string}>();

  public selectedCountryPlaceholder: string = '+46';
  public separateDialCode = false;
	public SearchCountryField = SearchCountryField;
	public CountryISO = CountryISO;
  public PhoneNumberFormat = PhoneNumberFormat;

  constructor(private helperService: HelperService) {}

  ngOnInit(){
    setTimeout(() => {
      this.ngxIntlTelInput.setDisabledState(this.disabled);
    }, 500);
  }

  phoneValue: string;


  /**
   * On changing country assigning custom place holder for selected country
   * @param $event
   */
  onCountryChange($event) {
    // Use only the dial code as placeholder instead of full example
    this.selectedCountryPlaceholder = $event?.dialCode ? `+${$event.dialCode}` : '+46';

    // Emit country selection to parent component
    this.countrySelected.emit({
      name: $event?.name || 'Sweden',
      dialCode: $event?.dialCode || '46'
    });

    if (this.phoneGroup) {
      this.helperService.updateTheLandCode($event, this.phoneGroup);
    }

  }


  // Called when the form control value changes
  writeValue(value): void {
    if (value) {
      this.phoneValue = value;
    }
  }

  // Register the onChange function
  registerOnChange(fn): void {
    this.onChange = fn;
  }

  // Register the onTouched function
  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  // Function to handle changes in phone input
  onTouched = () => {};

  onChange = (value) => {
    this.phoneValue = value; 
  };

  get landCode()  {
    return this.phoneGroup?.get('landcode')?.value ?? null;
  }

  get cssClass() {
    const baseClass = 'form-control country-input';
    const invalidClass = this.isFormSubmitted && this.formControl?.errors?.validatePhoneNumber?.valid === false
      ? 'is-invalid'
      : '';
    
    return `${baseClass} ${invalidClass} ${this.cssVariant}`.trim();
  }
}
